module.exports = __webpack_public_path__ + "static/media/new_lists_ru.70ab9d28.jpg";